import { OrderHouseTypes } from "./order-house-types";
import { OrderHousingTypes } from "./order-housing-types";

export class Order {

    //
    // Metadata
    // =========================================================================
    //

    locale: "nl" | "fr";

    //
    // Step 1:
    // Selecteer je klus
    // =========================================================================
    //

    /**
     * Q: Welke type isolatie?
     */
    public isolationType1: boolean;
    public isolationType2: boolean;
    public isolationType3: boolean;
    public isolationType4: boolean;
    public isolationType5: boolean;

    /**
     * Q: Welke type woning?
     */
    public houseType?: OrderHouseTypes;

    /**
     * Q: Huur- of koopwoning?
     */
    public housingType?: OrderHousingTypes;

    /**
     * Q: Bouwjaar woning?
     */
    public constructionYear?: number;

    //
    // Step 3:
    // Je contactgegevens
    // =========================================================================
    //

    /**
     * Q: Aanhef
     */
    public salutation?: string;

    /**
     * Q: Voornaam
     */
    public givenName?: string;

    /**
     * Q: Achternaam
     */
    public surName?: string;

    /**
     * Q: Tussenvoegsel
     */
    public insertion?: string;

    /**
     * Q: Postcode
     */
    public postcode?: string;

    /**
     * Q: Huisnummer
     */
    public number?: string;

    /**
     * Q: Toevoeging
     */
    public addition?: string;

    /**
     * Q: Straatnaam
     */
    public street?: string;

    /**
     * Q: Plaats
     */
    public city?: string;

    /**
     * Q: 1e Telefoonnummer
     */
    public firstPhoneNumber?: string;

    /**
     * Q: 2e Telefoonnummer
     */
    public secondPhoneNumber?: string;

    /**
     * Q: E-mailadres
     */
    public emailAddress?: string;

    /**
     * Q: Herhaal E-mailadres
     */
    public emailAddressRepeat?: string;

    //
    // Step 4:
    // Bevestiging van je aanvraag
    // =========================================================================
    //

    /**
     * Q: Ik heb de voorwaarden gelezen en ga hiermee akkoord.
     */
    public agreeWithTermsAndConditions?: boolean;

    /**
     * Q: Ik heb de productvoorwaarden gelezen en ga hiermee akkoord.
     */
    public agreeWithProductConditions?: boolean;

    //
    // Completed steps
    // =========================================================================
    //

    // Step 1
    public step1Completed = false;

    // Step 2
    public step2Completed = false;

    // Step 3
    public step3Completed = false;

    // Step 4
    public step4Completed = false;
}
